import ServiceCRUD from '../../../../services/ServiceCRUD';
import { apiCase as http } from '../../../../http';

class MatrixSLAService extends ServiceCRUD {
  constructor() {
    super('matrix-sla');
  }

  getWithoutPagination(showDisabled = false, recordTypeId = null) {
    return http.get(
      `${this.path}/all?showDisabled=${showDisabled}&recordTypeId=${recordTypeId}`
    );
  }

  listImpactsAndCriticalities(matrixSLAId) {
    return http.get(`${this.path}/${matrixSLAId}/impacts-criticalities`);
  }

  getMatrixSLA(queryParams) {
    return http.get(`${this.path}`, {
      params: queryParams
    });
  }

  getMatrixSLAById(id) {
    return http.get(`${this.path}/${id}`);
  }

  createMatrixSLA(data, usrLogin) {
    return http.post(this.path, data, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  updateMatrixSLA(id, data, usrLogin) {
    return http.put(`${this.path}/${id}`, data, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }

  enableDisableMatrixSLA(id, data, usrLogin) {
    return http.put(`${this.path}/${id}/enable-disable`, data, {
      headers: {
        'usr-login': usrLogin
      }
    });
  }
}

export default new MatrixSLAService();
